import React from "react";
import { Button } from "reactstrap";
import { FaRotateRight } from "react-icons/fa6";

const RefreshButton = ({
  onRefresh,
  isRefreshing = false,
  color = "primary",
  size = "sm",
  outline = true,
}) => {
  return (
    <Button
      color={color}
      size={size}
      outline={outline}
      onClick={onRefresh}
      disabled={isRefreshing}
    >
      <FaRotateRight
        className={`me-2 ${isRefreshing ? "fa-spin" : ""}`}
      />
      {isRefreshing ? "Refreshing..." : "Refresh"}
    </Button>
  );
};

export default RefreshButton;